

export class LoyaltyCardSearchRequest {
  reportType?: string;
  cardTypeId?: number;
  cardNumber?: string;
}
